export * from './base-highlight.component';
